import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function MadeInJordan() {
    const { t } = useTranslation();

    return (
        <>
            <section className="landingPages">
                <div className="container h-full flex items-center justify-between">
                    <div className="w-full md:w-[48%] flex flex-col">
                        <div className="text-[50px] font-bold capitalize text-white">{t("Made In Jordan")}</div>
                        <div className="font-bold text-[20px] text-white capitalize flex items-center gap-[7px]">
                            <Link className="text-white" to={"/"}>{t("Home")}</Link>
                            -
                            <div className="text-white">{t("Made In Jordan")}</div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="relative py-[40px]">
                <div className="container text-center">
                    <h2 className="text-[50px] font-bold">{t("Our Pride")}</h2>
                    <h3 className="text-[38px] font-semibold">{t("Made in Jordan")}</h3>
                    <p className="text-[25px] mt-4">{t("With the efforts and expertise of our heroes")}</p>
                    <p className="text-[22px] mt-2">{t("The energy, passion, and capabilities of our heroes deserve our utmost respect")}</p>
                    <p className="text-[22px] mt-2">{t("With the strength of our champions, nations are built")}</p>
                    <img
                        src={require("../../assets/image/made-in-jordan.jpg")}
                        alt="Made in Jordan"
                        className="mt-[20px] w-full h-full"
                    />
                </div>
            </section>
        </>
    );
}